/**
 * Email provider options shared across admin-ui surfaces (Infrastructure test
 * email, Email Test Harness). Single source of truth so a new provider is added
 * in exactly one place.
 */
import type { EmailProviderName } from '@/services/api'

export const EMAIL_PROVIDER_LABELS: Record<EmailProviderName, string> = {
  sendgrid: 'SendGrid',
  cloudflare: 'Cloudflare Email',
}

export const EMAIL_PROVIDER_OPTIONS: { value: EmailProviderName; label: string }[] = [
  { value: 'sendgrid', label: EMAIL_PROVIDER_LABELS.sendgrid },
  { value: 'cloudflare', label: EMAIL_PROVIDER_LABELS.cloudflare },
]
